import {Subject} from 'rxjs';
import {AuthService} from '../services/auth.service';
import {MarketLevel} from '../dto/market-level';
import {Market} from '../dto/market';
import {HttpClient} from '@angular/common/http';
import {DeviceDetectorService} from 'ngx-device-detector';
import { Injectable } from '@angular/core';
import { User } from '../dto/user';
import {BaseService} from '../services/base.service';

@Injectable( { providedIn: 'root' } )
export class MarketFilter {
    private _unsubscribeAll: Subject<any>;
    loggedUser: User;
    marketLevels: MarketLevel[] = [];
    markets = [];
    selectedMarket: Market[] = [];
    userRank: number;
    userMarketHierarchyLength = 0;
    filteredMarketLevels: MarketLevel[] = [];
    marketLevelFilterId = null;
    marketLevel = new MarketLevel();

    constructor( private http: HttpClient, private deviceService: DeviceDetectorService,  private auth: AuthService, private service: BaseService) {
        this._unsubscribeAll = new Subject();
        this.loggedUser = this.auth.user;
        this.marketLevels = this.loggedUser.MarketLevelHierarchy;
        if (this.loggedUser.UserRole.MarketLevel){
            this.userRank = this.loggedUser.UserRole.MarketLevel.Rank;
        }
        else {
            this.userRank = 0;
        }
        this.userMarketHierarchyLength = this.loggedUser.MarketLevelHierarchy.length;
        if (this.userRank > 0){
            if (this.userMarketHierarchyLength != this.userRank){
                this.marketLevelFilterId = this.marketLevels[this.userRank].Id;
                this.marketLevel = this.marketLevels[this.userRank];
            }
            else {
                this.marketLevelFilterId = this.marketLevels[this.userRank - 1].Id;
                this.marketLevel = this.marketLevels[this.userRank - 1];
            }
        }
        else {
            this.marketLevelFilterId = this.marketLevels[0].Id;
            this.marketLevel = this.marketLevels[0];
        }
    }

    prepareUserMarket(): Market[] {

        this.marketLevels.forEach( pMarketLevel => {
            this.markets[ pMarketLevel.Rank ] = [];
            this.selectedMarket[ pMarketLevel.Rank ] = null;
        } );

        if (this.loggedUser.UserMarketList){
            if (this.loggedUser.UserMarketList.length == 1) {
                this.loggedUser.UserMarketList.forEach( pMarket => {
                    if (pMarket.Market.ParentList){
                        pMarket.Market.ParentList.forEach( pParentMarket => {
                            this.selectedMarket [ pParentMarket.MarketLevel.Rank ] = pParentMarket;
                        });
                    }
                    this.selectedMarket[ this.userRank ] = this.loggedUser.UserMarketList[0].Market;
                });

            }
        }
        return this.selectedMarket;
    }
}
